import * as THREE from 'three';
export class KeypointsManagerFace {
  constructor() {
    this.rotationIndex = 1;

    this.faceVisible = false;
    this.faceLandmarks = [];
    this.adjustedFaceLandmarks = [];
    this.threefaceLandmarks = [];
    this.faceBlendshapes = null; // Stocker les blendshapes MediaPipe   


  }
  detectedFaceUpdate(results, settings, width, height) {

    this.faceVisible = results?.faceLandmarks?.length > 0;
    
    this.facialTransformationMatrix = results?.facialTransformationMatrixes?.[0];

    // Traiter les blendshapes si disponibles
    if (results?.faceBlendshapes?.length > 0) {
      this.faceBlendshapes = results.faceBlendshapes[0]; // Premier visage
    } else {
      this.faceBlendshapes = null;
    }

    if (this.faceVisible) {
      this.faceLandmarks = results.faceLandmarks[0]; // Assuming one face

      // Adapter les coordonnées à la résolution réduite
      this.adjustedFaceLandmarks = this.faceLandmarks.map(point => ({
        x: (-0.5 + point.x) * width,
        y: (0.5 - point.y) * height,
        z: -point.z * width
      }));

      this.threeFaceLandmarks = this.adjustedFaceLandmarks.map(point => new THREE.Vector3(point.x, point.y, point.z));

      this.positionsFace = {
        earL: this.threeFaceLandmarks[454],
        earR: this.threeFaceLandmarks[234],
        midEyes: this.threeFaceLandmarks[168],
        noseBottom: this.threeFaceLandmarks[2],
        leftEyeInnerCorner: this.threeFaceLandmarks[463],
        rightEyeInnerCorner: this.threeFaceLandmarks[243],
        leftEyeOuterCorner: this.threeFaceLandmarks[263],
        rightEyeOuterCorner: this.threeFaceLandmarks[33],
        upVector: new THREE.Vector3(),
        sideVector: new THREE.Vector3(),
        midEars: new THREE.Vector3(),
        eyeDist: 0,
        targetScale: 0,

        

      };
      this.rotationsFace = {
          neutralRotation: new THREE.Quaternion(), // Rotation neutre pour le modèle de visage
          headRotation: new THREE.Quaternion(),
      }

      this.scalesFace = {
        headScale: 0,
        neutralScale: 15
      }


      // Calculate midEars position
      this.positionsFace.midEars.set((this.positionsFace.earL.x + this.positionsFace.earR.x) / 2, (this.positionsFace.earL.y + this.positionsFace.earR.y) / 2, (this.positionsFace.earL.z + this.positionsFace.earR.z) / 2);
      this.positionsFace.upVector.subVectors(new THREE.Vector3(this.positionsFace.midEyes.x, this.positionsFace.midEyes.y, this.positionsFace.midEyes.z), new THREE.Vector3(this.positionsFace.noseBottom.x, this.positionsFace.noseBottom.y, this.positionsFace.noseBottom.z));
      this.positionsFace.upVector.normalize();
      if (this.rotationIndex == 0) this.positionsFace.sideVector.subVectors(new THREE.Vector3(this.positionsFace.leftEyeInnerCorner.x, this.positionsFace.leftEyeInnerCorner.y, this.positionsFace.leftEyeInnerCorner.z), new THREE.Vector3(this.positionsFace.rightEyeInnerCorner.x, this.positionsFace.rightEyeInnerCorner.y, this.positionsFace.rightEyeInnerCorner.z));
      else if (this.rotationIndex == 1) this.positionsFace.sideVector.subVectors(new THREE.Vector3(this.positionsFace.earL.x, this.positionsFace.earL.y, this.positionsFace.earL.z), new THREE.Vector3(this.positionsFace.earR.x, this.positionsFace.earR.y, this.positionsFace.earR.z));
      else if (this.rotationIndex == 2) this.positionsFace.sideVector.subVectors(new THREE.Vector3(this.positionsFace.leftEyeOuterCorner.x, this.positionsFace.leftEyeOuterCorner.y, this.positionsFace.leftEyeOuterCorner.z), new THREE.Vector3(this.positionsFace.rightEyeOuterCorner.x, this.positionsFace.rightEyeOuterCorner.y, this.positionsFace.rightEyeOuterCorner.z));
      this.positionsFace.sideVector.normalize();
      this.positionsFace.eyeDist = (this.threeFaceLandmarks[264].distanceTo(this.threeFaceLandmarks[356]) + this.threeFaceLandmarks[127].distanceTo(this.threeFaceLandmarks[34])) / 2;

      // Calcul du quaternion de rotation de la tête
      // On construit une matrice à partir des axes sideVector (x), upVector (y), et leur produit vectoriel (z)
      const xAxis = this.positionsFace.sideVector.clone().normalize();
      const yAxis = this.positionsFace.upVector.clone().normalize();
      const zAxis = new THREE.Vector3().crossVectors(xAxis, yAxis).normalize();
      // Re-orthogonaliser yAxis pour garantir l'orthogonalité
      yAxis.crossVectors(zAxis, xAxis).normalize();
      const rotMatrix = new THREE.Matrix4();
      rotMatrix.makeBasis(xAxis, yAxis, zAxis);
      this.rotationsFace.headRotation.setFromRotationMatrix(rotMatrix);

      
      this.scalesFace.headScale = this.positionsFace.eyeDist ;

         //console.log(this.facialTransformationMatrix)

    }


    // Ajout du retour des paramètres demandés
    return {
      faceLandmarks : this.faceLandmarks,
      faceVisible: this.faceVisible,
      threeLandmarks: this.threeFaceLandmarks,
      positionsFace: this.positionsFace,
      rotationsFace: this.rotationsFace,
      scalesFace: this.scalesFace,
      facialTransformationMatrix: this.facialTransformationMatrix,
      // Ajouter les méthodes pour les blendshapes
      getBlendshapes: () => this.getBlendshapes(),
      hasBlendshapes: () => this.hasBlendshapes()
    };
  }

  
  // calculateScale(threeLandmarks, settings) {
  //   const distEyes = this.threeFaceLandmarks[264].distanceTo(this.threeFaceLandmarks[356]) + this.threeFaceLandmarks[127].distanceTo(this.threeFaceLandmarks[34]);
  //   const distNoseMouth = this.threeFaceLandmarks[2].distanceTo(this.threeFaceLandmarks[58]);
  //   const distChinNose = this.threeFaceLandmarks[152].distanceTo(this.threeFaceLandmarks[2]);
  //   const distCheeksMouth = this.threeFaceLandmarks[234].distanceTo(this.threeFaceLandmarks[13]);


  //   const totalDistance = distEyes + distNoseMouth + distChinNose + distCheeksMouth;
  //   const averageScale = totalDistance / 4;


  //   return averageScale / settings.scaleFaceFactor;
  // }

  /**
   * Récupère les blendshapes sous forme d'objet avec noms et valeurs
   * @returns {Object|null} Objet avec les blendshapes ou null si non disponible
   */
  getBlendshapes() {
    if (!this.faceBlendshapes || !this.faceBlendshapes.categories) {
      return null;
    }

    const blendshapes = {};
    this.faceBlendshapes.categories.forEach(category => {
      if (category.categoryName && typeof category.score === 'number') {
        blendshapes[category.categoryName] = category.score;
      }
    });

    return blendshapes;
  }

  /**
   * Vérifie si des blendshapes sont disponibles
   * @returns {boolean} True si des blendshapes sont disponibles
   */
  hasBlendshapes() {
    return this.faceBlendshapes && 
           this.faceBlendshapes.categories && 
           this.faceBlendshapes.categories.length > 0;
  }


}

